import { linkHandler }               from 'ClientService';
import { useSelector }               from 'react-redux';
import { useEffect }                 from 'react';
import { getUser, userContainsRole } from 'Redux/Query';

export const useHasAccess = (route, redirectTo = 'documentUpload') => {
    const accessGroups = route?.access?.groups || [];
    const customCheck  = route?.sideBoard?.customVisibleCallback || (() => true);

    const user = useSelector(getUser);

    const hasAccess = useSelector(state => {
        if(!customCheck(route, { user })) {
            return false;
        }
        return userContainsRole(state)(accessGroups);
    });

    useEffect(() => {
        if (!hasAccess) {
            linkHandler.redirect(redirectTo);
        }
    }, [ hasAccess ]);
};
